import { Mail, Users, Briefcase } from "lucide-react";

const StayConnected = () => {
  return (
    <section
      name="connected"
      className="bg-light-olive px-5 py-6 lg:py-12 font-montserrat flex flex-col items-center"
    >
      <h1 className="font-medium text-dark-gray text-2xl lg:text-4xl text-center mb-1 lg:mb-3">
        STAY <span className="font-bold text-primary">CONNECTED</span>
      </h1>

      <p className="text-dark-gray text-sm lg:text-base text-center mb-4 lg:mb-6 max-w-md">
        Sign up to receive verified macro job opportunities and Macro Pathways updates.
      </p>

      {/* Icons Row */}
      <div className="flex items-center gap-4 lg:gap-6 mb-6">
        <div className="bg-light-gray p-4 rounded-full shadow-sm">
          <Mail className="text-primary w-6 h-6" />
        </div>
        <div className="bg-light-gray p-4 rounded-full shadow-sm">
          <Briefcase className="text-primary w-6 h-6" />
        </div>
        <div className="bg-light-gray p-4 rounded-full shadow-sm">
          <Users className="text-primary w-6 h-6" />
        </div>
      </div>

      {/* FORM CARD */}
      <div className="lg:w-5/12 w-full bg-white/80 backdrop-blur-sm p-6 lg:p-8 rounded-xl shadow-md border border-soft-gold/40">
        <form
          method="POST"
          action="https://zgnp-zngp.maillist-manage.com/weboptin.zc"
          target="_zcSignup"
          className="flex flex-col gap-4"
        >
          {/* Name fields */}
          <div className="flex flex-col lg:flex-row gap-3">
            <input
              type="text"
              name="FIRSTNAME"
              placeholder="First Name"
              className="w-full py-3 px-4 border border-gray-300 rounded-md focus:outline-soft-gold/30"
            />

            <input
              type="text"
              name="LASTNAME"
              placeholder="Last Name (optional)"
              className="w-full py-3 px-4 border border-gray-300 rounded-md focus:outline-soft-gold/30"
            />
          </div>

          {/* Email */}
          <input
            type="email"
            name="CONTACT_EMAIL"
            placeholder="Email Address"
            className="w-full py-3 px-4 border border-gray-300 rounded-md focus:outline-soft-gold/30"
          />

          {/* Hidden Zoho Fields */}
          <input type="hidden" name="submitType" value="optinCustomView" />
          <input type="hidden" name="formType" value="QuickForm" />
          <input type="hidden" name="zx" value="1358ac0fd" />
          <input type="hidden" name="zcvers" value="3.0" />
          <input type="hidden" name="mode" value="OptinCreateView" />
          <input type="hidden" name="zcld" value="11555e7266a98c231" />
          <input type="hidden" name="zctd" value="11555e7266a988b91" />
          <input type="hidden" name="zc_trackCode" value="ZCFORMVIEW" />
          <input
            type="hidden"
            name="zc_formIx"
            value="3ze907ba795c88dcd8923bfc46325a8b0eebff3d5a1e5d84751715521e664bea2d"
          />
          <input type="hidden" name="viewFrom" value="URL_ACTION" />

          {/* Button */}
          <button
            type="submit"
            className="bg-primary text-white text-base mt-2 py-3 rounded-lg shadow-md hover:opacity-90 hover:cursor-pointer transition w-full font-medium"
          >
            SIGN UP
          </button>
        </form>
      </div>
    </section>
  );
};

export default StayConnected;
